import { render, staticRenderFns } from "./NoSubscriptionWarning.vue?vue&type=template&id=05370c11&scoped=true&lang=pug&"
import script from "./NoSubscriptionWarning.vue?vue&type=script&lang=js&"
export * from "./NoSubscriptionWarning.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05370c11",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VContainer,VIcon})
